// components/landingPage/CTASection.jsx
import React from 'react';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-emerald-600 to-teal-700 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Transform Your Agribusiness?
        </h2>
        <p className="text-xl text-emerald-100 mb-8 max-w-2xl mx-auto">
          Join hundreds of Agro-dealers already turning waste into revenue and making a positive climate impact
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button className="bg-white text-emerald-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-2xl text-lg transition-all duration-300 transform hover:scale-105 shadow-lg">
            Start Free Trial
          </button>
          <button className="border-2 border-white text-white hover:bg-white/10 font-semibold py-4 px-8 rounded-2xl text-lg transition-all duration-300">
            Schedule Demo
          </button>
        </div>
        
        <p className="text-emerald-200 mt-6 text-sm">
          No credit card required • 14-day free trial • Cancel anytime
        </p>
      </div>
    </section>
  );
};

export default CTASection;